import React from "react";

type Tone = "light" | "warm" | "sand" | "ink" | "accent" | "gradient";

const TONES: Record<Tone, React.CSSProperties> = {
  light: {
    background: "var(--surface-card)",
    color: "var(--text-body)",
    border: "1px solid var(--border-default)",
  },
  warm: {
    background: "var(--cream-100)",
    color: "var(--text-body)",
    border: "1px solid var(--border-default)",
  },
  sand: {
    background: "var(--sand-200)",
    color: "var(--text-body)",
    border: "1px solid transparent",
  },
  ink: {
    background: "var(--ink-500)",
    color: "var(--text-on-dark)",
    border: "1px solid var(--ink-500)",
  },
  accent: {
    background: "var(--red-500)",
    color: "var(--white)",
    border: "1px solid var(--red-500)",
  },
  gradient: {
    background: "var(--gradient-brand)",
    color: "var(--white)",
    border: "1px solid transparent",
  },
};

interface CpCardProps {
  children: React.ReactNode;
  tone?: Tone;
  padding?: string;
  elevation?: "none" | "xs" | "sm" | "md" | "lg" | "xl";
  style?: React.CSSProperties;
}

/** Brand surface card (CertainPath Design System `Card`). */
const CpCard: React.FC<CpCardProps> = ({
  children,
  tone = "light",
  padding = "var(--space-8)",
  elevation = "sm",
  style,
}) => (
  <div
    style={{
      display: "block",
      padding,
      borderRadius: "var(--radius-card)",
      boxShadow: `var(--shadow-${elevation})`,
      ...TONES[tone],
      ...style,
    }}
  >
    {children}
  </div>
);

export default CpCard;
